import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import qs from 'qs'

import * as S from './styles'

import { IDataProductState, IPaginateParamsState, ISellerDataState } from './types'
import { banners } from './banners'

import ProductsCardList from '../../components/ProductsCardList'
import ButttonTop from '../../components/ButtonTop'
import Paginate from '../../components/Paginate'
import MaisConteudoAPi from '../../services/MaisConteudoAPi'
import FooterAddress from '../../components/FooterAddress'
import HeaderWishlist from '../../components/HeaderWishlist'

import { ReactComponent as NotFoundSVG } from '../../assets/notFound.svg'
import LogoFarm from '../../assets/farm_logo.svg'
import LogoFabula from '../../assets/fabula_logo.svg'
import LogoMariaFilo from '../../assets/mariaFilo_logo.svg'
import LogoOffPremium from '../../assets/offPremium_logo.svg'
import LogoAnimale from '../../assets/animale_logo.svg'

const Products: React.FC = () => {

    const mounted = useRef(false)

    const { linkName, code, linkId } = useParams()
    const [sellerData, setSellerData] = useState<ISellerDataState>({ active: 0, code: '', createdAt: '', id: 0, description: '', environment: '', linkId: '', name: '', affiliateName: '', products: [], vtexBanner: [] })
    const [isVisibleButtonTop, setVisibleButtonTop] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [WishlistNotExists, setWishlistNotExists] = useState(false)
    const [brand, setBrand] = useState({ name: "", logo: "", banner: ['', ''], to: "" })
    const items_per_page = 20
    const [paginateParams, setPaginateParams] = useState<IPaginateParamsState>({ to: items_per_page, from: 0 })

    const transformParamsInStringMemo = useMemo(() => {
        const to = paginateParams.to
        const from = paginateParams.from

        let newParamsObjt = { page: { to, from } }

        return qs.stringify(newParamsObjt)
    }, [paginateParams])

    const transformSellerParamsInStringMemo = useMemo(() => {
        if (linkName)
            return `${linkName}/${code}/${linkId}`
        else
            return `${linkId}`

    }, [code, linkId, linkName])

    const onFetchDataHandler = useCallback(async () => {
        try {
            const BannersBrands = [
                { name: "lojafarm", logo: LogoFarm, to: `https://www.farmrio.com.br/`, },
                { name: "lojaanimale", logo: LogoAnimale, to: 'https://www.animale.com.br/' },
                { name: "foxton", logo: '', to: '' },
                { name: "mariafilo", logo: LogoMariaFilo, to: 'https://www.mariafilo.com.br/' },
                { name: "lojacrisbarros", logo: '', to: ' ' },
                { name: "lojafabula", logo: LogoFabula, to: 'https://www.afabula.com.br/' },
                { name: "lojaabrand", logo: LogoOffPremium, to: ' ' },
                { name: "lojafyi", logo: LogoOffPremium, to: ' ' },
                { name: "lojaoffpremium", logo: LogoOffPremium, to: 'https://www.offpremium.com.br/' }
            ]
            setIsLoading(true)

            const res = await MaisConteudoAPi.get(`/v1/wishlists/${transformSellerParamsInStringMemo}/browse?${transformParamsInStringMemo}`)

            const sellerDataTemp = {
                ...res.data,
                products: res.data.products.filter(
                    (product: IDataProductState) => product.productId)
            }
            const vtexBanner = res.data.vtexBanner;

            const importedBanners = banners
                .filter(banner => banner.name === res.data.environment)
                .map(banner => banner.banner);

            const bannerImage = vtexBanner.length === 0 ? importedBanners[0][Math.floor(Math.random() * importedBanners[0].length)] : [vtexBanner.banner_mobile.url, vtexBanner.banner_desktop.url]

            if (mounted.current) {
                setSellerData((prevState: any) => ({ ...res.data, products: prevState.products.concat(sellerDataTemp.products) }))
                setBrand({ ...BannersBrands.filter(banner => banner.name === res.data.environment)[0], banner: bannerImage })
                setIsLoading(false)
            }

        } catch (error: any) {
            setIsLoading(false)
            if (error.response?.data.error.includes('error-unknown')) {
                setWishlistNotExists(true)
            }
        }
    }, [transformParamsInStringMemo, transformSellerParamsInStringMemo])

    const onNextPaginateHandler = useCallback(() => {
        setPaginateParams((prevState: IPaginateParamsState) => ({ ...prevState, to: prevState.to + items_per_page, from: prevState.from + items_per_page }))
    }, [])

    useEffect(() => {
        mounted.current = true
        onFetchDataHandler()
        return () => { mounted.current = false }
    }, [onFetchDataHandler])

    const shouldDisplayTopButton = () => {
        if (window.scrollY > 300) {
            return setVisibleButtonTop(true)
        }
        setVisibleButtonTop(false)
    }

    useEffect(() => {
        window.addEventListener('scroll', shouldDisplayTopButton)
        return () => {
            window.removeEventListener('scroll', shouldDisplayTopButton)
        }
    }, [])

    const handleReturnMessage = {
        svg: <NotFoundSVG />,
        body: 'Entre em contato com o vendedor',
        empty: {
            condition: !!sellerData.active,
            heading: 'Esta lojinha encontra-se sem produtos',
        },
        disabled: {
            condition: !sellerData.active,
            heading: 'Esta lojinha está fechada',
        },
    };

    const getMessage = useMemo(() => {
        return (
            (handleReturnMessage.empty.condition && handleReturnMessage.empty.heading) ||
            (handleReturnMessage.disabled.condition && handleReturnMessage.disabled.heading)
        )
    }, [handleReturnMessage.empty, handleReturnMessage.disabled])

    return (
        <S.Container>
            {
                (!isLoading && WishlistNotExists && !sellerData.code) ?
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <h2>Oops..</h2>
                        <br />
                        <span className='notFound-svg'>
                            <NotFoundSVG />
                        </span>
                        <h1>Não foi possível encontrar esta lojinha.</h1>
                        <p>Entre em contato com o vendedor</p>
                    </div>

                    :

                    <Paginate endMessage={'acabou'} loading={isLoading} loadDark={true} dataLength={sellerData.products.length} hasMore={true} next={onNextPaginateHandler}>
                        {
                            <>
                                {!isLoading &&
                                    <>
                                        <HeaderWishlist label={brand.logo} to={brand.to} sellerCode={sellerData.code} wishlistId={linkId} currentBrand={sellerData.environment} />
                                        <S.ImageHeader brandBanner={brand.banner} >
                                            <img src={brand.banner[1]} alt="carregando..." />
                                        </S.ImageHeader>
                                    </>}

                                <S.Content textColor={'#333'}>
                                    <h2>{sellerData.name}</h2>
                                    {!isLoading && <p className='bio'>{sellerData.code} - {sellerData.affiliateName}</p>}
                                    <p style={{ textAlign: 'center', margin: '12px 6px' }}>{sellerData.description}</p>

                                    <ButttonTop color={'#000'} isVisible={isVisibleButtonTop} />
                                    {!isLoading && <S.SeparateLine />}

                                    {(!isLoading && sellerData.products.length === 0) &&
                                        <S.WithoutProductsMessage>
                                            <span className='notFound-svg'>{handleReturnMessage.svg}</span>
                                            <h4>{getMessage}</h4>
                                            <p>{handleReturnMessage.body}</p>
                                        </S.WithoutProductsMessage>}

                                    <ProductsCardList
                                        textColor={'#333'}
                                        priceColor={'#999999'}
                                        shouldShowButton={true}
                                        shouldUseNewTag={false}
                                        products={sellerData.products}
                                        currentBrand={sellerData.environment}
                                        amountItems={4}
                                        sellerCode={sellerData.code}
                                        wishlistId={linkId}
                                    />
                                    {!isLoading && <FooterAddress />}
                                </S.Content>
                            </>
                        }

                    </Paginate>
            }

        </S.Container>
    )
}

export default Products